import { cleanHtml } from "../../lib/sanitize";

// Renders admin-authored rich HTML safely with the site's dark prose theme.
export default function RichContent({ html, className = "" }) {
  if (!html) return null;
  return (
    <div
      className={`cf-rich prose prose-invert max-w-none text-white/80 ${className}`}
      dangerouslySetInnerHTML={{ __html: cleanHtml(html) }}
    />
  );
}
